"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagsMultiple = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var PopoverWithOverlayClassname = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (react_1.default.createElement(antd_1.Popover, __assign({}, props, { overlayClassName: className })));
};
var StyledPopover = styled_components_1.default(PopoverWithOverlayClassname)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-popover-inner-content {\n    padding: 8px 6px;\n  }\n"], ["\n  .ant-popover-inner-content {\n    padding: 8px 6px;\n  }\n"])));
var isTagOption = function (obj) {
    var _a, _b;
    return (((_a = obj) === null || _a === void 0 ? void 0 : _a.label) !== undefined ||
        ((_b = obj) === null || _b === void 0 ? void 0 : _b.render) !== undefined);
};
var TagsMultiple = function (_a) {
    var _b = _a.tags, tags = _b === void 0 ? [] : _b, _c = _a.maxTagsToShow, maxTagsToShow = _c === void 0 ? 1 : _c, children = _a.children;
    var tagsToShow = tags.slice(0, maxTagsToShow);
    var otherTags = tags.slice(maxTagsToShow);
    return (react_1.default.createElement(antd_1.Row, { gutter: [8, 8] },
        tagsToShow.map(function (tag) { return (react_1.default.createElement(antd_1.Col, null, isTagOption(tag) && (tag === null || tag === void 0 ? void 0 : tag.render) ? (react_1.default.createElement(react_1.default.Fragment, null, tag === null || tag === void 0 ? void 0 : tag.render())) : (react_1.default.createElement(antd_1.Tag, { style: { margin: 0 }, color: isTagOption(tag) ? tag.color : undefined }, isTagOption(tag) ? tag.label : tag)))); }),
        !!(otherTags === null || otherTags === void 0 ? void 0 : otherTags.length) && (react_1.default.createElement(StyledPopover, { content: react_1.default.createElement(antd_1.Row, { style: { maxWidth: 200 }, gutter: [6, 6] }, otherTags === null || otherTags === void 0 ? void 0 : otherTags.map(function (tag) { return (react_1.default.createElement(antd_1.Col, null, isTagOption(tag) && (tag === null || tag === void 0 ? void 0 : tag.render) ? (react_1.default.createElement(react_1.default.Fragment, null, tag === null || tag === void 0 ? void 0 : tag.render())) : (react_1.default.createElement(antd_1.Tag, { color: isTagOption(tag) ? tag.color : undefined, style: { margin: 0 } }, isTagOption(tag) ? tag.label : tag)))); })) },
            react_1.default.createElement(antd_1.Col, null,
                react_1.default.createElement(antd_1.Tag, null, "+" + otherTags.length + "...")))),
        children));
};
exports.TagsMultiple = TagsMultiple;
var templateObject_1;
